import { GetNewReferenceNumber, GetNewReferenceNumberResponse } from '@/api/dtos';
import { useGet } from '@ngt/forms';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<GetNewReferenceNumberResponse, GetNewReferenceNumberResponse>) => response?.data?.referenceNumber;
const getError = (response?: SWRResponse<GetNewReferenceNumberResponse, GetNewReferenceNumberResponse>) => (response?.error ?? response?.data)?.responseStatus;

const useNewReferenceNumber = (configuration: SWRConfiguration = { 

}) => {

    const request = () => {
        return new GetNewReferenceNumber();
    }

    return useGet(request, { getData, getError }, configuration)
}

export default useNewReferenceNumber;
